import {ref, reactive, watch, Ref} from 'vue'

export default function Autocomplete(manager: any, multiple = false, extra_ajax_param = {}): any {

    const pending = ref(0);
    const isLoading = ref(false);
    const options = ref([] as any[]);
    const searchValue = ref('');
    const selection = multiple ? ref([] as any[]) : ref(null as null | any)
    const ajax_param = reactive(extra_ajax_param)
    const callBinds: Ref<any[]> = ref([]);

    // if (bind_to) {
    //     watch(
    //         selection,
    //         (new_value) => {
    //             if (new_value) {
    //                 if (multiple) {
    //                 if (multiple) {
    //                     bind_to = new_value.map((e: any) => e.id)
    //                 } else {
    //                     bind_to = new_value?.id || new_value
    //                 }
    //             }
    //         }
    //     )
    // }

    const search = async (search: string, debounce = 500, extra = {}) => {
        searchValue.value = search
        isLoading.value = true
        if (pending.value > 0) {
            clearTimeout(pending.value);
            pending.value = 0
        }
        return new Promise((resolve, reject) => {
            // @ts-ignore
            pending.value = setTimeout(function () {
                fetch(search, extra, resolve, reject)
            }, debounce)
        })
    }

    const fetch = (search: string, extra: any, scb: any, fcb: any) => {
        return manager.list(...callBinds.value, {params:{search: search, ...ajax_param, ...extra}}).then((response: any) => {
            if (Array.isArray(response.data)) {
                options.value = response.data
            } else {
                options.value = response.data.data
            }
        })
            .then(scb)
            .catch(fcb)
            .finally(() => {
                isLoading.value = false
            })
    }

    const retrieve = async (id: string | null) => {
        if (id === undefined || id === null) {
            return Promise.resolve()
        }
        isLoading.value = true
        return manager.retrieve(id).then((response: any) => {
            selection.value = response.data
            return response
        }).finally(() => {
            isLoading.value = false
        })
    }

    const retrieveAll = async (ids: string[]) => {
        if (ids.length === 0) {
            return Promise.resolve()
        }
        isLoading.value = true
        return manager.retrieveAll(ids).then((response: any) => {
            selection.value = response.data
            return response
        }).finally(() => {
            isLoading.value = false
        })
    }

    const add = (el: any): void => {
        if (el instanceof Array) {
            options.value.concat(...el)
            if (multiple) {
                selection.value.splice(0)
                selection.value.splice(0, 0, ...el)
            }
        } else {
            options.value.push(el)
            if (multiple) {
                selection.value.push(el)
            } else {
                selection.value = el
            }
        }
    }

    const empty = (): void => {
        if (multiple) {
            selection.value.splice(0)
        } else {
            selection.value = null
        }
    }

    const emptyAll = (): void => {
        empty()
        options.value.splice(0)
    }

    const deleteAjaxParam = (key: string): void => {
        // @ts-ignore
        delete ajax_param[key]
    }
    const addAjaxParam = (key: string, value: any): void => {
        // @ts-ignore
        ajax_param[key] = value
    }

    return {
        isLoading,
        options,
        selection,
        callBinds,
        searchValue,
        search,
        retrieve,
        add,
        empty,
        emptyAll,
        addAjaxParam,
        deleteAjaxParam,
        retrieveAll
    }
}
